import { ITokenInfo } from "~/types/global"
import { axiosInstance } from "~/utils/axios"

export async function getAskOSChatHistory(
  tokenInfo: ITokenInfo,
  { templateFill = false }: { templateFill?: boolean } = {}
) {
  // `template_fill=true` asks the BE to additionally derive a per-session
  // `is_template_fill` flag (a join on the chat-history turns' template files).
  // Only the agentOS "Fill Templates" drawer needs it, so it's opt-in — the
  // standalone history list omits it and skips the extra subquery.
  return await axiosInstance({
    method: "GET",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/sessions?feature=ASKOS${
      templateFill ? "&template_fill=true" : ""
    }`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`,
      "Content-Type": "application/json"
    }
  })
}

export async function searchAskOSChatHistory(
  tokenInfo: ITokenInfo,
  query: string
) {
  // Searches the user's Ask OS (V2) sessions by message CONTENT — the user's
  // query text AND the LLM's response — case-insensitive substring, newest
  // first. Distinct from getAskOSChatHistory (which only lists sessions by
  // title); the BE joins agent_session_chat_history to match on message text.
  return await axiosInstance({
    method: "GET",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/sessions/search?feature=ASKOS&q=${encodeURIComponent(
      query
    )}`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`,
      "Content-Type": "application/json"
    }
  })
}

export async function createOsAgentsSession(
  tokenInfo: ITokenInfo,
  question: string = ""
) {
  const url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/session`
  return await axiosInstance({
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    },
    data: {
      feature: "ASKOS",
      question: question
    }
  })
}

export async function getAgentTools(tokenInfo: ITokenInfo) {
  const url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/agent_tools`
  return await axiosInstance({
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function getKosTools(tokenInfo: ITokenInfo) {
  const url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/kos_tools`
  return await axiosInstance({
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function getChatSuggestions(
  tokenInfo: ITokenInfo,
  chatId: string,
  accountId: string,
  surface: string = "accountOS",
  rfpId?: string,
  msgId?: string
) {
  let url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/chat/${chatId}/${accountId}/suggestions?surface=${surface}`
  if (rfpId) {
    url += `&rfp_id=${rfpId}`
  }
  if (msgId) {
    url += `&msg_id=${msgId}`
  }
  return await axiosInstance({
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function getUserPrompts(tokenInfo: ITokenInfo) {
  const url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/get_prompts`
  return await axiosInstance({
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}
